/*
 * Copyright Thoughtworks, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// noinspection ES6UnusedImports
import m from "mithril";
import _ from "lodash";
import inflection from "lodash-inflection";
import {timeFormatter as TimeFormatter} from "helpers/time_formatter";
import {renderCommentToHtmlByType} from "helpers/render_comment";

export const MaterialSearchResultsWidget = {
  view(vnode) {
    const material = vnode.attrs.material;

    const searchInProgress = material.searchInProgress();
    const searchText       = material.searchText();
    const results          = material.searchResults() || [];

    let resultMessage;

    if (searchInProgress) {
      return null;
    }

    if (_.isEmpty(results)) {
      resultMessage = <span class="helper">No revisions found matching '{searchText}'</span>;
    } else if (_.isEmpty(searchText)) {
      resultMessage = <span class="helper">Last {inflection.pluralize('commit', results.length, true)} listed in chronological order</span>;
    }

    const commitInfos = _.map(results, (result) => {
      const li = (
        <li onclick={() => {
          material.selectRevision(result.revision);
        }}>
          <div class="info">
            <span class="rev">{result.revision}</span>
            <span class="committer">{result.user}</span>
            <span class="time">{TimeFormatter.format(result.date)}</span>
          </div>
          <div class="commit_message">{m.trust(renderCommentToHtmlByType(result.comment, material.type))}</div>
        </li>
      );
      return li;
    });

    return (
      <div class="commits">
        {resultMessage}
        <ul class="commit_info">
          {commitInfos}
        </ul>
      </div>
    );
  }
};
